import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { getSchedule, getMeta } from "../lib/api";
import { GameCard } from "../components/GameCard";

export default function Schedule() {
  const [params, setParams] = useSearchParams();
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: getMeta });
  const week = Number(params.get("week")) || meta?.currentWeek || 1;

  const { data: games = [], isLoading } = useQuery({
    queryKey: ["schedule", week],
    queryFn: () => getSchedule(week),
    enabled: !!week,
  });

  const weeks = Array.from({ length: meta?.totalWeeks || 18 }, (_, i) => i + 1);

  return (
    <div data-testid="schedule-page" className="space-y-6">
      <div className="flex items-end justify-between border-b-2 border-border pb-2">
        <h1 className="font-display text-5xl">SCHEDULE</h1>
        <span className="label-caps">{meta?.season} Regular Season</span>
      </div>

      <div data-testid="week-selector" className="flex flex-wrap gap-1 border border-border p-1 bg-card">
        {weeks.map((w) => (
          <button
            key={w}
            data-testid={`week-btn-${w}`}
            onClick={() => setParams({ week: String(w) })}
            className={`w-11 h-10 text-sm font-bold transition-colors duration-150 ${
              w === week
                ? "bg-primary text-black"
                : "text-muted-foreground hover:bg-white/5 hover:text-foreground"
            }`}
          >
            {w}
          </button>
        ))}
      </div>

      <h2 className="font-display text-3xl text-primary">WEEK {week}</h2>

      {isLoading ? (
        <p className="text-muted-foreground">Loading games…</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {games.map((g) => (
            <GameCard key={g.id} game={g} />
          ))}
        </div>
      )}
    </div>
  );
}
